// Medias qualification
export const REJECTION_REASONS = [
  'Qualité insuffisante - Résolution trop faible',
  'Qualité insuffisante - Compression excessive',
  'Image floue ou pixelisée',
  'Mauvais format - Format non accepté',
  'Mauvais format - Ratio incorrect',
  'Mauvais cadrage - Produit coupé',
  "Mauvais cadrage - Trop de vide dans l'image",
  'Problème de luminosité - Image trop sombre',
  'Problème de luminosité - Image surexposée',
  'Problème de contraste insuffisant',
  'Couleurs non fidèles au produit',
  'Arrière-plan inapproprié',
  "Présence d'éléments indésirables",
  'Vidéo - Durée inadaptée',
  'Vidéo - Qualité audio insuffisante',
  'Vidéo - Résolution minimale non respectée (4K requis)',
  'Autre (préciser dans le commentaire)',
];

export const MEDIA_QUALIFICATION_SORT_OPTIONS = [
  { label: 'Date (récent)', value: '-created_at' },
  { label: 'Date (ancien)', value: 'created_at' },
  { label: 'Nom (A-Z)', value: 'name' },
  { label: 'Nom (Z-A)', value: '-name' },
  { label: 'Taille (croissant)', value: 'size' },
  { label: 'Taille (décroissant)', value: '-size' },
];

export const MEDIAS_TYPES_OPTIONS = [
  { label: 'Images', value: 'image' },
  { label: 'Vidéos', value: 'video' },
  { label: 'Documents', value: 'document' },
];

export const MEDIA_FORMATS_OPTIONS = [
  { label: 'JPG', value: 'jpg' },
  { label: 'PNG', value: 'png' },
  { label: 'GIF', value: 'gif' },
  { label: 'SVG', value: 'svg' },
  { label: 'MP4', value: 'mp4' },
  { label: 'AVI', value: 'avi' },
  { label: 'PDF', value: 'pdf' },
  { label: 'DOCX', value: 'docx' },
];

export const MEDIA_DIMENSIONS_OPTIONS = [
  { label: 'Carré (1:1)', value: '1:1' },
  { label: 'Portrait (3:4)', value: '3:4' },
  { label: 'Paysage (16:9)', value: '16:9' },
  { label: 'Panoramique (21:9)', value: '21:9' },
];

export const MEDIA_DATE_PERIOD_OPTIONS = [
  { label: "Aujourd'hui", value: 'today' },
  { label: 'Cette semaine', value: 'week' },
  { label: 'Ce mois', value: 'month' },
  { label: 'Cette année', value: 'year' },
];

export const MEDIA_FILE_SIZE_OPTIONS = [
  { label: 'Moins de 1 MB', value: 'null-1000' },
  { label: '1 MB - 10 MB', value: '1000-10000' },
  { label: '10 MB - 100 MB', value: '10000-100000' },
  { label: 'Plus de 100 MB', value: '100000-null' },
];

export const MEDIA_STATUS_OPTIONS = [
  { label: 'Tous', value: 'all' },
  { label: 'À qualifier', value: 'to_qualify' },
  { label: 'À valider', value: 'to_validate' },
  { label: 'Validé', value: 'validated' },
  { label: 'Rejeté', value: 'rejected' },
  { label: 'Archivé', value: 'archived' },
];

export const MEDIA_RESOLUTION_OPTIONS = [
  { label: 'Basse (< 720p)', value: 'null-720' },
  { label: 'HD (720p - 1080p)', value: '720-1080' },
  { label: 'Full HD (1080p - 2160p)', value: '1080-2160' },
  { label: '4K et plus (> 2160p)', value: '2160-null' },
];

export const MAX_SELECTED_MEDIAS = 1000;
